// extracted by mini-css-extract-plugin
module.exports = {"AlertWrapper":"AlertComponent_AlertWrapper__3_dSU","WarningAlert":"AlertComponent_WarningAlert__3zURk"};